const groupPrefix = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.PROMOTION_RULES)
const groupPrefixStore = createApiRoute(ApiModule.ORDER, ApiAuthorization.EMPLOYEE, ApiDataModel.PROMOTIONS)

export const apiPromotionRules = {
	createPromotionRule: async (
		promotionId: number,
		payload: IDiscountPromotionRuleCreatePayload,
	): Promise<IDiscountPromotionRuleModel> => {
		const { data } = await apiCommon<IDiscountPromotionRule>(`${groupPrefixStore}/${promotionId}/promotion-rules`, {
			method: 'POST',
			body: payload,
		})

		return DiscountPromotionRule(data)
	},
	deletePromotionRule: async (ruleId: number): Promise<void> => {
		await apiCommon(`${groupPrefix}/${ruleId}`, { method: 'DELETE' })
	},
}
